import { Languages } from '../enums';
import { LanguageOption } from '../interfaces';

export const AVAILABLE_LANGUAGES: LanguageOption[] = [
  { value: Languages.EN_GB, viewValue: 'English (UK)' },
  { value: Languages.ES_ES, viewValue: 'Español' },
];

export const ADMIN = 'Admin';
